export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warn',
  ERROR: 'error'
}

export type MessageType = (typeof NOTIFICATION_TYPES)[keyof typeof NOTIFICATION_TYPES]

export const NOTIFICATION_TOAST_VISIBILITY = { STICKY: 0 }
NOTIFICATION_TOAST_VISIBILITY[NOTIFICATION_TYPES.INFO] = 2500
NOTIFICATION_TOAST_VISIBILITY[NOTIFICATION_TYPES.SUCCESS] = 2500
NOTIFICATION_TOAST_VISIBILITY[NOTIFICATION_TYPES.WARNING] = 0
NOTIFICATION_TOAST_VISIBILITY[NOTIFICATION_TYPES.ERROR] = 0

// Messages sent from Backend
export interface Message {
  message: string
  type: MessageType
  delayInMS?: number
}
